import React from "react";
import { AppleLogo, GooglePlayLogo } from "phosphor-react";

const Index = () => {
  return (
    <>
      <div className="py-12 px-4 lg:px-24 bg-slate-100 items-center text-center">
        <div className="mb-10">
          <p className="inline px-4 py-2 text-xs lg:text-base bg-red-400 rounded-full text-white leading-8">
            Download App
          </p>
          <h1 className="text-2xl lg:text-5xl text-slate-700 font-bold mb-4 lg:leading-[72px]">
            Our Mobile Apps now <br /> is Available
          </h1>
          <p className="text-sm lg:text-lg text-slate-500 font-normal">
            Our Apps now Available on App Store and Google Playstore
          </p>
        </div>
        <div className="flex flex-col lg:flex-row items-center text-center justify-center space-y-3 lg:space-x-6 lg:space-y-0">
          <button className="flex transition-all duration-300 ease-in-out hover:-translate-y-3 hover:bg-slate-800 hover:shadow-2xl space-x-3 items-center bg-slate-900 text-white rounded-xl py-2 px-7">
            <AppleLogo size={32} weight="fill" />
            <div className="text-left">
              <p className="text-xs">Download on the</p>
              <p className="text-xl">App Store</p>
            </div>
          </button>
          <button className="flex transition-all duration-300 ease-in-out hover:-translate-y-3 hover:bg-slate-800 hover:shadow-2xl space-x-3 items-center bg-slate-900 text-white rounded-xl py-2 px-7">
            <GooglePlayLogo size={32} weight="fill" />
            <div className="text-left">
              <p className="text-xs">Download on the</p>
              <p className="text-xl">Google Play</p>
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default Index;
